import React, { useRef, useState, useEffect } from 'react';

const MOCK_COVER_LETTERS = {
  harvard_professional: {
    name: "Avery Davis",
    email: "avery.davis@harvard.edu",
    phone: "+1 (555) 019-2834",
    city: "Boston, MA",
    company: "McKinsey & Company",
    job_title: "Associate Consultant",
    content: "Dear Hiring Team,\n\nI am writing to express my enthusiastic interest in the Associate Consultant position at McKinsey & Company. As a graduate with experience in strategic analysis and corporate modeling, I am drawn to McKinsey's commitment to solving the world's most complex business challenges.\n\nDuring my academic tenure, I led a student consulting group that optimized operations for local non-profits, achieving a 20% reduction in overhead. I am confident that my analytical background and leadership skills will allow me to deliver immediate value to your client teams.\n\nThank you for your time and consideration. I look forward to the possibility of discussing how my skills align with McKinsey's goals.\n\nSincerely,\nAvery Davis"
  },
  modern_professional: {
    name: "Estelle Darcy",
    email: "estelle.darcy@gmail.com",
    phone: "+1 (555) 302-9104",
    city: "San Francisco, CA",
    company: "Stripe",
    job_title: "Senior Product Manager",
    content: "Dear Hiring Manager,\n\nI am thrilled to apply for the Senior Product Manager position at Stripe. With over five years of experience leading cross-functional teams to launch scalable SaaS APIs, I have long admired Stripe's developer-first philosophy and engineering excellence.\n\nAt my previous role, I spearheaded the redesign of our core subscription engine, resulting in a 35% increase in checkout conversion rates and onboarding over 10,000 new developers. I look forward to bringing my passion for building intuitive fintech products to your team.\n\nThank you for reviewing my application. I would welcome the opportunity to discuss how my background can support Stripe's growth.\n\nBest regards,\nEstelle Darcy"
  },
  executive_letter: {
    name: "Sarah Jenkins",
    email: "s.jenkins@executive.com",
    phone: "+1 (555) 839-1029",
    city: "New York, NY",
    company: "Vanguard Group",
    job_title: "Director of Portfolio Management",
    content: "Dear Members of the Selection Committee,\n\nI am writing to submit my application for the Director of Portfolio Management position. With over fifteen years of fiduciary leadership and a proven track record of managing multi-billion dollar asset allocations, I am eager to align my expertise with Vanguard's client-first mission.\n\nThroughout my career, I have successfully navigated volatile market cycles, consistently delivering returns that outpaced benchmarks by 150 basis points. I look forward to bringing my institutional knowledge and commitment to risk management to Vanguard.\n\nThank you for your consideration. I look forward to discussing how my strategic vision can contribute to Vanguard's continued success.\n\nSincerely,\nSarah Jenkins"
  },
  startup_letter: {
    name: "Cole Harris",
    email: "cole@harris.dev",
    phone: "+1 (555) 482-0192",
    city: "Austin, TX",
    company: "Retool",
    job_title: "Founding Engineer",
    content: "Hey Retool Team,\n\nI'm writing to apply for the Founding Engineer role. I've been using Retool since the early days, and the speed at which you guys ship features to help developers build internal tools is absolutely incredible.\n\nI love building from scratch. At my last startup, I was employee #3 and built our entire real-time dashboard using Retool and custom React components, saving our support team 20+ hours a week. I'm excited to help build the future of internal software with you.\n\nThanks for building such an awesome product, and I hope to chat soon!\n\nBest,\nCole Harris"
  },
  creative_letter: {
    name: "Liam Vance",
    email: "liam@vancedesign.co",
    phone: "+1 (555) 728-1092",
    city: "Brooklyn, NY",
    company: "Figma",
    job_title: "Lead Product Designer",
    content: "Dear Figma Design Team,\n\nI am writing to express my interest in the Lead Product Designer position at Figma. As a designer who spends 8 hours a day in Figma, the opportunity to help design the very tool that empowers millions of creatives is incredibly inspiring.\n\nOver the past six years, I have led design systems at high-growth startups, focusing on creating harmonious UI patterns that bridge the gap between design and code. I would love to bring my systems-thinking approach to Figma's product team.\n\nThank you for your time, and I look forward to sharing my portfolio and discussing how we can shape the future of design tools together.\n\nWarmly,\nLiam Vance"
  },
  academic_letter: {
    name: "Dr. Evelyn Stone",
    email: "evelyn.stone@stanford.edu",
    phone: "+1 (555) 293-1029",
    city: "Stanford, CA",
    company: "Stanford University",
    job_title: "Assistant Professor of Computer Science",
    content: "Dear Members of the Search Committee,\n\nI am writing to formally apply for the position of Assistant Professor within the Department of Computer Science at Stanford University. My primary research interests lie at the intersection of machine learning systems and distributed databases.\n\nI completed my Ph.D. at MIT, where my dissertation on automated query optimization in heterogeneous clusters received the Outstanding Thesis Award. I am prepared to establish a robust, externally-funded research program and teach core curriculum courses.\n\nThank you for your review of my application materials, including my curriculum vitae, research statement, and teaching portfolio.\n\nRespectfully yours,\nDr. Evelyn Stone"
  },
  government_letter: {
    name: "John R. Doe",
    email: "john.doe@hq.doe.gov",
    phone: "+1 (555) 902-1823",
    city: "Washington, DC",
    company: "Department of Energy",
    job_title: "Senior Program Analyst",
    content: "Dear Hiring Authority,\n\nI am writing to submit my application for the Senior Program Analyst vacancy (Announcement #DOE-2026-092) at the Department of Energy. I possess over a decade of experience in public administration, federal compliance, and budget orchestration.\n\nIn my previous role at the Department of Transportation, I oversaw the auditing of regional infrastructure grants, identifying cost efficiencies that saved taxpayers over $4.2 million. I hold an active Secret clearance and am fully versed in federal reporting guidelines.\n\nThank you for your consideration of my qualifications for this critical public service role.\n\nRespectfully,\nJohn R. Doe"
  },
  sales_letter: {
    name: "Marcus Sterling",
    email: "marcus.sterling@sales.com",
    phone: "+1 (555) 819-2039",
    city: "Chicago, IL",
    company: "Salesforce",
    job_title: "Enterprise Account Executive",
    content: "Dear Salesforce Recruiting Team,\n\nI am writing to apply for the Enterprise Account Executive position. As a top-performing enterprise software sales professional with a history of exceeding quotas, I am eager to drive revenue growth for Salesforce.\n\nAt my current firm, I closed $3.1 million in new business last year alone, achieving 135% of my annual quota and securing 4 new Fortune 500 accounts. I am ready to leverage my consultative selling methodology to expand Salesforce's enterprise footprint.\n\nThank you for your time, and I look forward to discussing how I can hit the ground running and deliver immediate pipeline growth.\n\nBest regards,\nMarcus Sterling"
  },
  product_manager_letter: {
    name: "David K. Chen",
    email: "david@chenpm.io",
    phone: "+1 (555) 392-1029",
    city: "Seattle, WA",
    company: "Airbnb",
    job_title: "Senior Technical Product Manager",
    content: "Dear Airbnb Product Team,\n\nI am writing to express my interest in the Technical Product Manager position at Airbnb. With a background in computer science and product leadership, I am excited about the prospect of enhancing Airbnb's search personalization engines.\n\nPreviously, I led the search relevance team at an e-commerce giant, deploying ML models that increased search-to-cart conversion by 18%. I understand the complexity of marketplace search and look forward to building features that make discovery seamless.\n\nThank you for your consideration. I look forward to discussing how my technical background aligns with Airbnb's product roadmap.\n\nSincerely,\nDavid K. Chen"
  },
  finance_letter: {
    name: "Charles M. Vance",
    email: "charles.vance@goldman.com",
    phone: "+1 (555) 293-1029",
    city: "London, UK",
    company: "Goldman Sachs",
    job_title: "Investment Banking Associate",
    content: "Dear Members of the Recruitment Committee,\n\nI am writing to submit my application for the Investment Banking Associate position within the Global Markets division at Goldman Sachs. My analytical training and dedication to excellence align with the firm's standards.\n\nPrior to completing my MBA at London Business School, I spent three years as a valuation analyst, executing financial modeling and due diligence for transactions exceeding £1.2 billion. I look forward to contributing my structuring experience to your team.\n\nThank you for your time and consideration of my candidacy.\n\nSincerely,\nCharles M. Vance"
  },
  internship_letter: {
    name: "Aisha Patel",
    email: "aisha.patel@university.edu",
    phone: "+1 (555) 782-9102",
    city: "Seattle, WA",
    company: "Microsoft",
    job_title: "Software Engineering Intern",
    content: "Dear Microsoft Internship Program Team,\n\nI am writing to apply for the Software Engineering Intern position for Summer 2026. As a junior pursuing a B.S. in Computer Science, I am eager to apply my academic foundation to Microsoft's developer tools division.\n\nThrough my coursework and personal projects, I have built strong skills in Java, Python, and cloud services. I recently built a collaborative code-editor app that was used by 150+ students in my department. I am excited to learn from Microsoft's world-class engineers.\n\nThank you for opportunity, and I look forward to discussing how I can contribute to Microsoft this summer.\n\nBest regards,\nAisha Patel"
  },
  career_change_letter: {
    name: "Jordan Blake",
    email: "jordan.blake@hubspot.com",
    phone: "+1 (555) 492-1029",
    city: "Boston, MA",
    company: "HubSpot",
    job_title: "Customer Success Manager",
    content: "Dear HubSpot Hiring Team,\n\nI am writing to express my strong interest in transitioning my career into customer success as a Customer Success Manager at HubSpot. With six years of B2B sales experience, I am ready to focus on driving long-term customer value.\n\nIn my sales roles, I found that my greatest satisfaction came from onboarding and educating clients to maximize their ROI, resulting in a 95% client retention rate. I am excited to apply this customer-centric mindset to help HubSpot's clients succeed.\n\nThank you for your consideration of my transferable skills and my enthusiasm for HubSpot's customer-first culture.\n\nSincerely,\nJordan Blake"
  }
};

export default function CoverLetterPreviewSVG({ templateId, accent }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(0.25);

  useEffect(() => {
    if (!containerRef.current) return;
    const updateScale = () => {
      // Guard: ref may be null if the component unmounted between observer setup and callback
      if (!containerRef.current) return;
      const width = containerRef.current.getBoundingClientRect().width;
      if (width > 0) {
        setScale(width / 720); // Scale relative to standard preview width 720px
      }
    };
    updateScale();
    const el = containerRef.current;
    const observer = new ResizeObserver(updateScale);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const accentColor = accent || '#7C3AED';

  // Always use beautiful template-specific mock cover letter data for the gallery cards
  const letter = MOCK_COVER_LETTERS[templateId] || MOCK_COVER_LETTERS['harvard_professional'];

  const ownerName  = letter.name;
  const ownerEmail = letter.email;
  const ownerPhone = letter.phone;
  const ownerCity  = letter.city;

  const resolveSafeDate = (iso, formatType = "long") => {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    try {
      if (formatType === "iso-short") {
        return d.toISOString().split('T')[0];
      }
      return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    } catch {
      return "";
    }
  };

  const rawContent = letter.content || '';
  const paragraphs = rawContent
    .split('\n\n')
    .map((p) => `<p>${p.replace(/\n/g, '<br/>')}</p>`)
    .join('');

  let fontFamily = "'Georgia', serif";
  let bodyStyle = "font-size: 13.5pt; color: #1a1a1a; line-height: 1.75; margin: 0;";
  let headerHtml = "";

  if (templateId === 'harvard_professional') {
    fontFamily = "'Times New Roman', Times, 'Georgia', serif";
    bodyStyle = "font-size: 13.5pt; color: #111111; line-height: 1.65; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    const dateHtml = dateStr ? `<div style="font-size: 11pt; color: #666; margin-top: 8px;">Date: ${dateStr}</div>` : '';
    headerHtml = `
      <div style="text-align: center; border-bottom: 1.5px solid #222; padding-bottom: 12px; margin-bottom: 24px;">
        <div style="font-size: 22pt; font-weight: bold; font-family: ${fontFamily}; text-transform: uppercase; letter-spacing: 0.5px; color: #000;">${ownerName}</div>
        <div style="font-size: 11.5pt; color: #444; margin-top: 4px; font-family: ${fontFamily};">
          ${ownerEmail} &nbsp;|&nbsp; ${ownerPhone} &nbsp;|&nbsp; ${ownerCity}
        </div>
      </div>
      <div style="margin-bottom: 20px;">
        <div style="font-weight: bold; font-size: 13pt; color: #111;">To,</div>
        <div style="font-size: 13pt; color: #222; margin-top: 2px;">
          The Hiring Team <br/>
          ${letter.company || "Company"} <br/>
          Ref: Application for ${letter.job_title || "Position"}
        </div>
        ${dateHtml}
      </div>
    `;
  } else if (templateId === 'executive_letter') {
    fontFamily = "'Calibri', 'Arial', sans-serif";
    bodyStyle = "font-size: 13.5pt; color: #2d3748; line-height: 1.7; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    const dateHtml = dateStr ? `<div style="font-size: 11pt; color: #a0aec0; margin-top: 4px;">Date: ${dateStr}</div>` : '';
    headerHtml = `
      <div style="border-left: 4px solid ${accentColor}; padding-left: 14px; margin-bottom: 28px; padding-top: 4px; padding-bottom: 4px;">
        <div style="font-size: 24pt; font-weight: 800; color: #1a202c; letter-spacing: -0.5px;">${ownerName}</div>
        <div style="font-size: 14pt; font-weight: 600; color: ${accentColor}; margin-top: 2px;">Application for ${letter.job_title || ""}</div>
        <div style="font-size: 11.5pt; color: #718096; margin-top: 6px;">
          ${ownerEmail} &bull; ${ownerPhone} &bull; ${ownerCity}
        </div>
        ${dateHtml}
      </div>
      <div style="margin-bottom: 20px; font-size: 13pt; color: #4a5568;">
        <strong>Attention:</strong> Hiring Representative at ${letter.company || "Company"}
      </div>
    `;
  } else if (templateId === 'faang_engineering') {
    fontFamily = "Consolas, Menlo, Monaco, 'Courier New', monospace";
    bodyStyle = "font-size: 12.5pt; color: #111827; line-height: 1.7; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date(), "iso-short");
    const dateHtml = dateStr ? `<strong>TIMESTAMP:</strong> ${dateStr}<br/>` : '';
    headerHtml = `
      <div style="border: 1px solid #10B981; border-left: 4px solid #10B981; padding: 12px; margin-bottom: 24px; border-radius: 4px; font-family: ${fontFamily}; background: #F0FDF4;">
        <span style="color: #047857; font-weight: bold;">$ cat cover_letter.txt</span>
        <div style="font-size: 11.5pt; color: #065F46; margin-top: 6px; line-height: 1.4;">
          <strong>CANDIDATE:</strong> ${ownerName}<br/>
          <strong>COMPANY:</strong> ${letter.company || "Target_Company"}<br/>
          <strong>POSITION:</strong> ${letter.job_title || "Role"}<br/>
          ${dateHtml}
        </div>
      </div>
    `;
  } else if (templateId === 'startup_letter') {
    fontFamily = "'Inter', sans-serif";
    bodyStyle = "font-size: 13.5pt; color: #1a202c; line-height: 1.75; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    headerHtml = `
      <div style="margin-bottom: 24px;">
        <div style="font-size: 22pt; font-weight: 800; color: #1a202c;">${ownerName}</div>
        <div style="font-size: 11.5pt; color: #4b5563; margin-top: 4px;">
          ${ownerEmail} &bull; ${ownerPhone} &bull; ${ownerCity}
        </div>
        <div style="font-size: 11pt; color: #9ca3af; margin-top: 8px;">Date: ${dateStr}</div>
      </div>
      <div style="margin-bottom: 20px; font-size: 13pt;">
        To the team at <strong>${letter.company || "Company"}</strong>,
      </div>
    `;
  } else if (templateId === 'creative_letter') {
    fontFamily = "'Inter', sans-serif";
    bodyStyle = "font-size: 13.5pt; color: #2d3748; line-height: 1.75; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    headerHtml = `
      <div style="display: flex; gap: 14px; margin-bottom: 24px; border-left: 5px solid ${accentColor}; padding-left: 14px;">
        <div>
          <div style="font-size: 24pt; font-weight: 900; color: #111827;">${ownerName}</div>
          <div style="font-size: 12pt; color: #4b5563; margin-top: 2px;">
            ${ownerEmail} &bull; ${ownerPhone} &bull; ${ownerCity}
          </div>
          <div style="font-size: 11pt; color: ${accentColor}; font-weight: 600; margin-top: 4px;">Date: ${dateStr}</div>
        </div>
      </div>
    `;
  } else if (templateId === 'academic_letter') {
    fontFamily = "'Times New Roman', Georgia, serif";
    bodyStyle = "font-size: 13.5pt; color: #111; line-height: 1.75; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    headerHtml = `
      <div style="text-align: center; margin-bottom: 30px;">
        <div style="font-size: 22pt; font-family: 'Times New Roman'; font-style: italic;">${ownerName}</div>
        <div style="font-size: 11.5pt; color: #555; margin-top: 6px;">
          ${ownerEmail} &bull; ${ownerPhone} &bull; ${ownerCity}
        </div>
        <div style="font-size: 11.5pt; color: #555; margin-top: 4px;">${dateStr}</div>
      </div>
    `;
  } else if (templateId === 'government_letter') {
    fontFamily = "Arial, sans-serif";
    bodyStyle = "font-size: 13.5pt; color: #111; line-height: 1.65; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    headerHtml = `
      <div style="background: #F3F4F6; border: 1px solid #D1D5DB; padding: 16px; margin-bottom: 24px; border-radius: 4px;">
        <div style="font-size: 18pt; font-weight: bold; color: #111827;">${ownerName}</div>
        <div style="font-size: 11.5pt; color: #4B5563; margin-top: 4px;">
          ${ownerEmail} | ${ownerPhone} | ${ownerCity}
        </div>
        <div style="font-size: 11.5pt; color: #4B5563; margin-top: 2px;">Date: ${dateStr}</div>
      </div>
    `;
  } else if (templateId === 'sales_letter') {
    fontFamily = "Arial, sans-serif";
    bodyStyle = "font-size: 13.5pt; color: #111827; line-height: 1.65; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    headerHtml = `
      <div style="border-top: 4px solid ${accentColor}; padding-top: 14px; margin-bottom: 24px;">
        <div style="font-size: 24pt; font-weight: 800; color: #111827; letter-spacing: -0.5px;">${ownerName}</div>
        <div style="font-size: 11.5pt; color: #4B5563; margin-top: 4px;">
          ${ownerEmail} &bull; ${ownerPhone} &bull; ${ownerCity}
        </div>
        <div style="font-size: 11.5pt; color: #4B5563; margin-top: 2px;">Date: ${dateStr}</div>
      </div>
    `;
  } else if (templateId === 'finance_letter') {
    fontFamily = "Georgia, serif";
    bodyStyle = "font-size: 13.5pt; color: #111; line-height: 1.65; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    headerHtml = `
      <div style="text-align: center; border: 1.5px solid #000; padding: 14px; margin-bottom: 24px;">
        <div style="font-size: 20pt; font-weight: bold; font-family: Georgia; color: #000;">${ownerName}</div>
        <div style="font-size: 11pt; color: #444; margin-top: 6px;">
          ${ownerEmail} | ${ownerPhone} | ${ownerCity}
        </div>
        <div style="font-size: 11pt; color: #444; margin-top: 2px;">Date: ${dateStr}</div>
      </div>
    `;
  } else { // modern_professional / default
    fontFamily = "'Helvetica Neue', Helvetica, Arial, sans-serif";
    bodyStyle = "font-size: 13.5pt; color: #1f2937; line-height: 1.75; margin: 0;";
    const dateStr = resolveSafeDate(letter.created_at || new Date());
    const dateHtml = dateStr ? `<div style="font-size: 10.5pt; color: #9ca3af; margin-top: 4px;">${dateStr}</div>` : '';
    headerHtml = `
      <div style="display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid ${accentColor}; padding-bottom: 16px; margin-bottom: 24px;">
        <div>
          <div style="font-size: 24pt; font-weight: 700; color: #111827; letter-spacing: -0.5px;">${ownerName}</div>
          <div style="font-size: 14pt; color: ${accentColor}; font-weight: 600; margin-top: 2px;">${letter.job_title || ""}</div>
        </div>
        <div style="text-align: right; font-size: 11.5pt; color: #4b5563; line-height: 1.4;">
          <div>${ownerEmail}</div>
          <div>${ownerPhone}</div>
          <div>${ownerCity}</div>
          ${dateHtml}
        </div>
      </div>
      <div style="margin-bottom: 18px; font-size: 12.5pt; color: #374151;">
        <strong>To:</strong> Hiring Team at <strong>${letter.company || "Company"}</strong>
      </div>
    `;
  }

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8"/>
  <style>
    @page { margin: 10mm 8mm; size: A4 portrait; }
    body { font-family: ${fontFamily}; ${bodyStyle}; padding: 0; margin: 0; box-sizing: border-box; }
    .content-area { font-family: ${fontFamily}; }
    p { margin: 0 0 20px; }
  </style>
</head>
<body style="padding: 24px;">
  <div class="content-area">
    ${headerHtml}
    ${paragraphs}
  </div>
</body>
</html>`;

  return (
    <div ref={containerRef} style={{
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
      background: '#fff',
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '720px',
        height: '1000px',
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        pointerEvents: 'none',
        userSelect: 'none',
      }}>
        <iframe
          title={`Cover Letter Mini Preview - ${templateId}`}
          srcDoc={html}
          style={{ width: "100%", height: "100%", border: "none", pointerEvents: 'none', overflow: 'hidden' }}
        />
      </div>
    </div>
  );
}
